import { generateContext } from '@btime/react-contexts'
import React from 'react'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useExecutionDynamicServiceOrders = () => React.useContext(StateContext)
export const useExecutionDynamicServiceOrdersActions = () => React.useContext(ActionsContext)

const Form = ({ children }) => {
  const [form, setForm] = React.useState({})

  return (
    <Provider state={form} actions={{ setForm }}>
      {children}
    </Provider>
  )
}

export default Form
